import React, { useEffect } from 'react';
import CommonIn from '../utils/CommonIn';
import FaqSection from '../components/FaqSection'; // FaqSection 컴포넌트를 불러옵니다.

const Support = () => {
  // 아코디언 토글 로직은 FaqSection 컴포넌트 내부로 이동되었으므로 여기서는 제거합니다.
  // const toggleAccordion = (header) => { ... };

  useEffect(() => {
    // 컴포넌트 마운트 후 실행될 코드
    CommonIn(); // CommonIn이 전역적인 초기화 등을 담당한다면 유지합니다.
    // 아코디언 관련 DOM 조작 로직은 FaqSection으로 이동했으므로 여기서는 제거합니다.
  }, []); // 빈 의존성 배열은 컴포넌트가 처음 렌더링될 때 한 번만 실행됨을 보장

  return (
    <>
      <main className="submain" id="submain">
        <div className="sub_header">
          <div className="container sub_header_inner">
            <h1>고객지원</h1>
          </div>
        </div>
        <div className="submenu support_submenu">
          <div className="container">
            <div className="submenu_inner">
              <ul>
                <li><a href="/support" className="active">FAQ</a></li>
                <li><a href="/notice">공지사항</a></li>
              </ul>
            </div>
          </div>
        </div>
        <section className="visual_sec solution_vs">
          <div className="container visual_inner">
            <div className="visual_text">
              <h2>FAQ</h2>
              <p>찾으시는 답변이 없으신가요?<br />언제든지 문의해 주시면 빠르게 답변드리겠습니다.</p>
            </div>
          </div>
        </section>
        <section className="ac_area">
          <div className="container">
              <FaqSection /> {/* 불러온 FaqSection 컴포넌트를 사용합니다. */}
          </div>
        </section>
      </main>
    </>
  );
};

export default Support;
